import { render } from "./GoogleReCaptchaV3.vue?vue&type=template&id=4ae41e00"
import script from "./GoogleReCaptchaV3.vue?vue&type=script&lang=js"
export * from "./GoogleReCaptchaV3.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/survey-cms/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__